// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"65167709","909":"11d81702"}[chunkId] + ".chunk.js";
};